module.exports = __webpack_public_path__ + "img/deepsleep.svg";